import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError, tap } from 'rxjs';
import { toastrConfig, TOKEN_HEADER_KEY } from '../../app.config';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private injector: Injector,
              private translateService: TranslateService,
              private toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const token = localStorage.getItem(TOKEN_HEADER_KEY);
    let requestToHandle = req;

    if (token) {
      requestToHandle = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
        setHeaders: {
          [TOKEN_HEADER_KEY]: token
        }
      });
    }

    return next.handle(requestToHandle).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          authService.refreshAuthentication(event);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status >= 500) {
          authService.logoutOnError(error);
        }
        if (error.status === 401) {
          this.toastr.info(this.translateService.instant("LOGIN.EXPIRED_TOKEN"), "", toastrConfig);
          authService.clearAuth();
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
